package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.DateRange
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.List
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.PlayArrow
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathEffect
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.drawText
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.rememberTextMeasurer
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import br.com.htms.inspeccaocampo.data.FormRemSeguranca
import br.com.htms.inspeccaocampo.data.RemAusencia
import br.com.htms.inspeccaocampo.data.somaHoras
import br.com.htms.inspeccaocampo.data.RemAbrangencia
import br.com.htms.inspeccaocampo.data.RemCalc
import br.com.htms.inspeccaocampo.data.RemFmt
import br.com.htms.inspeccaocampo.data.RemIndicadores
import br.com.htms.inspeccaocampo.data.RemMeses
import br.com.htms.inspeccaocampo.data.RemMetas
import br.com.htms.inspeccaocampo.data.remMetasFromJson
import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.data.RemMonthPayload
import br.com.htms.inspeccaocampo.data.RemMonthRow
import br.com.htms.inspeccaocampo.data.RemOcorrenciasBreakdown
import br.com.htms.inspeccaocampo.data.RemResumoAno
import br.com.htms.inspeccaocampo.data.RemVisao
import br.com.htms.inspeccaocampo.form.AppController
import kotlinx.coroutines.launch
import br.com.htms.inspeccaocampo.shared.ui.components.CenteredAppDialog
import br.com.htms.inspeccaocampo.ui.kit.Campo
import br.com.htms.inspeccaocampo.ui.kit.CartaoSecao
import br.com.htms.inspeccaocampo.ui.kit.ItemPainel
import br.com.htms.inspeccaocampo.ui.kit.Kpi
import br.com.htms.inspeccaocampo.ui.kit.PaineisDoDash
import br.com.htms.inspeccaocampo.ui.kit.LinhaKpis
import br.com.htms.inspeccaocampo.ui.kit.LinhaOpcoes
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.data.funcionarios.Funcionario
import br.com.htms.inspeccaocampo.data.funcionarios.FuncionariosApi
import br.com.htms.inspeccaocampo.ui.kit.Seletor
import br.com.htms.inspeccaocampo.ui.kit.SeletorBusca
import br.com.htms.inspeccaocampo.ui.theme.PortalCores

private val LocalRemMetas = compositionLocalOf { RemMetas() }

private enum class AbaRem(val rotulo: String, val icone: ImageVector) {
    PAINEL("Dashboard", Icons.Filled.Home),
    LANCAR("Lançamento mensal", Icons.Filled.Edit),
    ANUAL("Planilha anual", Icons.Filled.List),
    ADMIN("Administração", Icons.Filled.Settings)
}

@Composable
fun SharedRemSegurancaScreen(controller: AppController) {
    val form by controller.remForm.collectAsState()
    val obrasAtivas by controller.obrasAtivas.collectAsState()
    val salvando by controller.remSalvando.collectAsState()
    val baixando by controller.remBaixando.collectAsState()
    val authUser by controller.authUser.collectAsState()
    val isMaster = authUser?.isMaster == true
    val aberto = !form.dossierId.isNullOrBlank()

    var aba by remember { mutableStateOf(AbaRem.PAINEL) }
    var visao by remember { mutableStateOf(RemVisao.CONSOLIDADO) }
    var apresentar by remember { mutableStateOf(false) }
    var confirmarZerar by remember { mutableStateOf<String?>(null) }
    var metas by remember { mutableStateOf(RemMetas()) }

    LaunchedEffect(Unit) { controller.carregarObrasAtivas() }
    LaunchedEffect(Unit) {
        AuthApi.fetchRemMetasJson().onSuccess { metas = remMetasFromJson(it) }
    }

    CompositionLocalProvider(LocalRemMetas provides metas) {
    val meses = remember(form) { RemCalc.mesesAtuais(form) }

    confirmarZerar?.let { escopo ->
        CenteredAppDialog(
            onDismissRequest = { confirmarZerar = null },
            title = when (escopo) {
                "mes" -> "Zerar mês"
                "obra_ano" -> "Zerar obra/ano"
                else -> "Zerar REM geral"
            },
            text = when (escopo) {
                "mes" -> "Apagar TODOS os dados do mês ${RemMeses.rotulo(form.mes)}/${form.ano} da obra \"${form.obra}\" " +
                    "(HTMS e Subcontratados, todos os usuários)? Esta ação não pode ser desfeita."
                "obra_ano" -> "Apagar TODOS os dossiês REM da obra \"${form.obra}\" em ${form.ano} " +
                    "(todos os meses e usuários)? Esta ação não pode ser desfeita."
                else -> "Apagar TODO o REM no servidor (todas as obras, anos e usuários)? Esta ação não pode ser desfeita."
            },
            confirmLabel = "Zerar",
            onConfirm = {
                controller.zerarRemAdmin(escopo)
                confirmarZerar = null
            },
            dismissLabel = "Cancelar"
        )
    }

    if (apresentar && aberto) {
        ApresentacaoRem(form.obra, form.ano, meses, visao, { visao = it }) { apresentar = false }
    }

    val isAdmin = authUser?.isAdmin == true
    val itens = AbaRem.entries.filter { it != AbaRem.ADMIN || isAdmin }.map { PortalMenuItem(it.name, it.rotulo, it.icone) }
    PortalModulo(
        titulo = if (aberto) "REM ${form.ano} — ${form.obra}" else "REM — Relatório Estatístico Mensal",
        itens = itens,
        selecionado = aba.name,
        onSelect = { aba = AbaRem.valueOf(it) },
        extraCabecalho = {
            if (aberto) {
                PortalOutlinedButton(onClick = { apresentar = true }) {
                    Icon(Icons.Filled.PlayArrow, contentDescription = null, modifier = Modifier.size(18.dp))
                    Spacer(Modifier.width(6.dp))
                    Text("Apresentar")
                }
                Spacer(Modifier.width(8.dp))
                PortalButton(onClick = { controller.baixarRemExcel() }, enabled = !baixando) {
                    Text(if (baixando) "Gerando..." else "Baixar Excel")
                }
            }
        }
    ) { largo ->
        CartaoDossie(controller, form, obrasAtivas.map { it.nome }, salvando, largo)
        if (aberto) {
            when (aba) {
                AbaRem.PAINEL -> {
                    SeletorVisao(visao) { visao = it }
                    DashboardRem(meses, visao, largo, grande = false)
                }
                AbaRem.LANCAR -> LancamentoRem(controller, form, meses, salvando, largo)
                AbaRem.ANUAL -> {
                    SeletorVisao(visao) { visao = it }
                    PlanilhaAnualRem(meses, visao) { abr, mes ->
                        if (abr != form.abrangencia) controller.selecionarRemAbrangencia(abr)
                        controller.selecionarRemMes(mes)
                        aba = AbaRem.LANCAR
                    }
                }
                AbaRem.ADMIN -> AdminRem(controller, form, salvando, isMaster, metas, { metas = it }) { confirmarZerar = it }
            }
        }
    }
    }
}

// ---------- Obra / ano ----------

@Composable
private fun CartaoDossie(
    controller: AppController,
    form: FormRemSeguranca,
    obras: List<String>,
    salvando: Boolean,
    largo: Boolean
) {
    val aberto = !form.dossierId.isNullOrBlank()
    val opObras = (obras + form.obra).filter { it.isNotBlank() }.distinct().map { it to it }
    val opAnos = ((2024..2030) + form.ano).distinct().sorted().map { it.toString() to it.toString() }
    CartaoSecao(
        titulo = "Obra e ano",
        subtitulo = if (aberto) "Dossiê aberto. Trocar a obra ou o ano fecha este dossiê."
        else "Escolha a obra e o ano e abra o dossiê. Ele guarda os 12 meses do REM (HTMS e subcontratados)."
    ) {
        val obra: @Composable (Modifier) -> Unit = { m ->
            Seletor("Obra", opObras, form.obra, { controller.atualizarRemObra(it) }, m)
        }
        val ano: @Composable (Modifier) -> Unit = { m ->
            Seletor("Ano", opAnos, form.ano.toString(), { v -> v.toIntOrNull()?.let { controller.atualizarRemAno(it) } }, m)
        }
        val botao: @Composable (Modifier) -> Unit = { m ->
            PortalButton(
                onClick = { controller.abrirOuCriarRemDossier() },
                enabled = form.obra.isNotBlank() && !salvando,
                modifier = m
            ) { Text(if (aberto) "Recarregar" else "Abrir dossiê") }
        }
        if (largo) {
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(12.dp), verticalAlignment = Alignment.CenterVertically) {
                obra(Modifier.weight(2f))
                ano(Modifier.weight(1f))
                botao(Modifier)
            }
        } else {
            obra(Modifier.fillMaxWidth())
            ano(Modifier.fillMaxWidth())
            botao(Modifier.fillMaxWidth())
        }
    }
}

@Composable
internal fun SeletorVisao(visao: RemVisao, onVisao: (RemVisao) -> Unit) {
    LinhaOpcoes(
        opcoes = RemVisao.entries,
        selecionada = visao,
        rotulo = { it.rotulo },
        cor = { PortalCores.Navy },
        onSelect = onVisao,
        modifier = Modifier.widthIn(max = 720.dp)
    )
}

// ---------- Dashboard ----------

private fun corMeta(v: Double?, meta: Double, menorMelhor: Boolean): Color = when {
    v == null -> PortalCores.CinzaClaro
    (if (menorMelhor) v <= meta else v >= meta) -> PortalCores.Verde
    else -> PortalCores.Vermelho
}

private val CorLesaoCom = Color(0xFFC62828)
private val CorLesaoSem = Color(0xFFE07B00)
private val CorAmbulatorial = Color(0xFFF2B33D)
private val CorTrajeto = Color(0xFF6A4FB3)
private val CorHtms get() = PortalCores.Navy
private val CorSub = Color(0xFF4F8FD8)

@Composable
internal fun ColumnScope.DashboardRem(meses: List<RemMonthRow>, visao: RemVisao, largo: Boolean, grande: Boolean) {
    val meta = LocalRemMetas.current
    val serie = remember(meses, visao) { RemCalc.serie(meses, visao) }
    val r = remember(serie) { RemCalc.resumo(serie) }
    val t = r.total
    if (r.mesesComDados == 0) {
        CartaoSecao(
            titulo = "Sem dados lançados",
            subtitulo = "Nenhum mês preenchido para ${visao.rotulo}. Use Lançamento mensal para informar os números."
        ) {}
        return
    }
    val ate = r.ultimoMes?.let { " · até ${RemMeses.rotulo(it)}" }.orEmpty()

    PaineisDoDash("rem", largo, organizar = !grande, itens = listOf(
        ItemPainel("kpis", "Indicadores do ano", inteiro = true) {
            LinhaKpis(largo) { m ->
        Kpi("HHER no ano", RemFmt.num(t.hher, 0), Icons.Filled.DateRange, m, legenda = "${r.mesesComDados} mês(es) lançado(s)$ate")
        Kpi("Média de colaboradores", RemFmt.num(r.mediaColaboradores, 0), Icons.Filled.Person, m, legenda = "meses com efetivo informado")
        Kpi(
            "Acidentes com afastamento", RemFmt.qtd(t.lesaoCom), Icons.Filled.Warning, m, alerta = t.lesaoCom > 0,
            legenda = "sem afastamento: ${RemFmt.qtd(t.lesaoSem)} · ambulatorial: ${RemFmt.qtd(t.lesaoAmb)}"
        )
        Kpi(
            "Dias perdidos", RemFmt.qtd(t.diasPerdidos), Icons.Filled.Warning, m, alerta = t.diasPerdidos > 0,
            legenda = "CAT emitidas: ${RemFmt.qtd(t.cat)}"
        )
        Kpi(
            "Trajeto e danos", RemFmt.qtd(t.acidentesTrajeto), Icons.Filled.Warning, m, alerta = t.acidentesTrajeto > 0,
            legenda = "acidentes de trajeto · danos à propriedade: ${RemFmt.qtd(t.danos)}"
        )
    }
        },
        ItemPainel("taxas", "Taxas e metas", inteiro = true) {
            LinhaKpis(largo) { m ->
                KpiMeta("TFCA (com afastamento)", r.tfca, meta.tfca, true, m) { RemFmt.taxa(it) }
                KpiMeta("TFSA (sem afastamento)", r.tfsa, meta.tfsa, true, m) { RemFmt.taxa(it) }
                KpiMeta("Taxa de gravidade (TG)", r.tg, meta.tg, true, m) { RemFmt.taxa(it) }
                KpiMeta("Absenteísmo", r.absenteismo, meta.absenteismo, true, m) { RemFmt.pct(it) }
                KpiMeta("Treinamento", r.treinamento, meta.treinamento, false, m) { RemFmt.pct(it) }
            }
        },
        ItemPainel("tfca", "TFCA") { m ->
            val taxa: (Double) -> String = { RemFmt.num(it, 2) }
            GraficoLinha("TFCA — acidentes com afastamento", "Acumulada no ano, por milhão de HHER", serie.map { it.tfcaAcum }, meta.tfca, true, taxa, m, grande)
        },
        ItemPainel("tfsa", "TFSA") { m ->
            val taxa: (Double) -> String = { RemFmt.num(it, 2) }
            GraficoLinha("TFSA — acidentes sem afastamento", "Acumulada no ano, por milhão de HHER", serie.map { it.tfsaAcum }, meta.tfsa, true, taxa, m, grande)
        },
        ItemPainel("tg", "Taxa de gravidade") { m ->
            val taxa: (Double) -> String = { RemFmt.num(it, 2) }
            GraficoLinha("Taxa de gravidade (TG)", "Dias perdidos acumulados por milhão de HHER", serie.map { it.tgAcum }, meta.tg, true, taxa, m, grande)
        },
        ItemPainel("absenteismo", "Absenteísmo") { m ->
            val pct: (Double) -> String = { RemFmt.pct(it) }
            GraficoLinha("Absenteísmo", "Horas de absenteísmo ÷ HHER, no mês", serie.map { it.absenteismo }, meta.absenteismo, true, pct, m, grande)
        },
        ItemPainel("treinamento", "Treinamento") { m ->
            val pct: (Double) -> String = { RemFmt.pct(it) }
            GraficoLinha("Treinamento", "Homem-hora de treinamento ÷ HHER, no mês", serie.map { it.treinamento }, meta.treinamento, false, pct, m, grande)
        },
        ItemPainel("hher", "HHER por mês") { m ->
            val series = if (visao == RemVisao.CONSOLIDADO) {
                listOf(
                    SerieBarra("HTMS", CorHtms, RemCalc.serie(meses, RemVisao.HTMS).map { it.valores.hher }),
                    SerieBarra("Subcontratados", CorSub, RemCalc.serie(meses, RemVisao.SUBCONTRATADOS).map { it.valores.hher })
                )
            } else listOf(SerieBarra(visao.rotulo, CorHtms, serie.map { it.valores.hher }))
            GraficoBarras("HHER por mês", "Homem-hora de exposição ao risco", series, { RemFmt.num(it, 0) }, m, grande)
        },
        ItemPainel("ocorrencias-mes", "Ocorrências por mês") { m ->
            GraficoBarras(
                "Ocorrências por mês", "Com lesão e de trajeto",
                listOf(
                    SerieBarra("Com afastamento", CorLesaoCom, serie.map { it.valores.lesaoCom }),
                    SerieBarra("Sem afastamento", CorLesaoSem, serie.map { it.valores.lesaoSem }),
                    SerieBarra("Ambulatorial", CorAmbulatorial, serie.map { it.valores.lesaoAmb }),
                    SerieBarra("Trajeto", CorTrajeto, serie.map { it.valores.acidentesTrajeto })
                ),
                { RemFmt.qtd(it) }, m, grande
            )
        },
        ItemPainel("ocorrencias-ano", "Ocorrências no ano") { m -> OcorrenciasAno(r, m) }
    ))
}

@Composable
private fun KpiMeta(titulo: String, v: Double?, meta: Double, menorMelhor: Boolean, modifier: Modifier, fmt: (Double) -> String) {
    val ok = v != null && (if (menorMelhor) v <= meta else v >= meta)
    Kpi(
        titulo = titulo,
        valor = v?.let(fmt) ?: "—",
        icone = if (ok) Icons.Filled.CheckCircle else Icons.Filled.Warning,
        modifier = modifier,
        cor = corMeta(v, meta, menorMelhor),
        legenda = "meta ${if (menorMelhor) "≤" else "≥"} ${fmt(meta)}" + if (v == null) "" else if (ok) " · dentro da meta" else " · fora da meta"
    )
}

@Composable
private fun OcorrenciasAno(r: RemResumoAno, modifier: Modifier) {
    val t = r.total
    val linhas = listOf(
        Triple("Lesão com afastamento", t.lesaoCom, CorLesaoCom),
        Triple("Lesão sem afastamento", t.lesaoSem, CorLesaoSem),
        Triple("Simples atendimento ambulatorial", t.lesaoAmb, CorAmbulatorial),
        Triple("Trajeto com afastamento", t.trajCom, CorTrajeto),
        Triple("Trajeto sem afastamento", t.trajSem, CorTrajeto),
        Triple("Trajeto ambulatorial", t.trajAmb, CorTrajeto),
        Triple("Danos à propriedade", t.danos, PortalCores.CinzaTexto),
        Triple("CAT emitidas", t.cat, PortalCores.AzulIcone)
    )
    val maior = linhas.maxOf { it.second }.takeIf { it > 0 } ?: 1.0
    CartaoSecao("Ocorrências no ano", modifier, "Totais de janeiro até o último mês lançado") {
        linhas.forEach { (rotulo, valor, cor) ->
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(rotulo, Modifier.width(200.dp), style = MaterialTheme.typography.bodyMedium, color = PortalCores.Texto)
                Box(Modifier.weight(1f).height(14.dp).background(PortalCores.CabecalhoTabela, RoundedCornerShape(7.dp))) {
                    if (valor > 0) {
                        Box(Modifier.fillMaxWidth((valor / maior).toFloat()).height(14.dp).background(cor, RoundedCornerShape(7.dp)))
                    }
                }
                Text(
                    RemFmt.qtd(valor), Modifier.width(48.dp), textAlign = TextAlign.End,
                    fontWeight = FontWeight.SemiBold, color = if (valor > 0) cor else PortalCores.CinzaClaro
                )
            }
        }
        Text(
            "Dias perdidos (lesão): ${RemFmt.qtd(t.diasPerdidos)} · transportados: ${RemFmt.qtd(t.diasTransportados)} · " +
                "debitados: ${RemFmt.qtd(t.diasDebitados)} · trajeto: ${RemFmt.qtd(t.trajDiasPerdidos)} dia(s)",
            style = MaterialTheme.typography.bodySmall,
            color = PortalCores.CinzaTexto
        )
    }
}

@Composable
private fun RotulosMeses(recuo: Dp) {
    Row(Modifier.fillMaxWidth().padding(start = recuo)) {
        RemMeses.rotulos.forEach {
            Text(
                it, Modifier.weight(1f), textAlign = TextAlign.Center,
                style = MaterialTheme.typography.labelSmall, color = PortalCores.CinzaTexto
            )
        }
    }
}

@Composable
private fun ItemLegenda(cor: Color, texto: String, tracejado: Boolean = false) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        Canvas(Modifier.width(22.dp).height(10.dp)) {
            drawLine(
                cor, Offset(0f, size.height / 2), Offset(size.width, size.height / 2), 5f,
                pathEffect = if (tracejado) PathEffect.dashPathEffect(floatArrayOf(8f, 5f)) else null
            )
        }
        Spacer(Modifier.width(6.dp))
        Text(texto, style = MaterialTheme.typography.labelMedium, color = PortalCores.CinzaTexto)
    }
}

private val LarguraEixo = 58.dp

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun GraficoLinha(
    titulo: String,
    subtitulo: String,
    valores: List<Double?>,
    meta: Double,
    menorMelhor: Boolean,
    fmt: (Double) -> String,
    modifier: Modifier,
    grande: Boolean
) {
    val medidor = rememberTextMeasurer()
    val altura = if (grande) 280.dp else 210.dp
    val maiorValor = valores.filterNotNull().maxOrNull() ?: 0.0
    val topo = maxOf(meta * 1.3, maiorValor * 1.2).takeIf { it > 0 } ?: 1.0
    val corLinha = PortalCores.AzulIcone
    val corMetaLinha = PortalCores.Vermelho
    val estiloRotulo = TextStyle(fontSize = if (grande) 12.sp else 10.sp, fontWeight = FontWeight.SemiBold)
    CartaoSecao(titulo, modifier, subtitulo) {
        Row(Modifier.fillMaxWidth()) {
            Column(
                Modifier.width(LarguraEixo - 6.dp).height(altura),
                verticalArrangement = Arrangement.SpaceBetween,
                horizontalAlignment = Alignment.End
            ) {
                listOf(topo, topo / 2, 0.0).forEach {
                    Text(fmt(it), style = MaterialTheme.typography.labelSmall, color = PortalCores.CinzaClaro, maxLines = 1)
                }
            }
            Spacer(Modifier.width(6.dp))
            Canvas(Modifier.weight(1f).height(altura)) {
                val w = size.width
                val h = size.height
                fun y(v: Double) = (h - (v / topo) * h).toFloat()
                fun x(i: Int) = w * (i + 0.5f) / 12f
                listOf(0.0, topo / 2, topo).forEach {
                    drawLine(PortalCores.Borda, Offset(0f, y(it)), Offset(w, y(it)), 1.5f)
                }
                drawLine(
                    corMetaLinha.copy(alpha = 0.85f), Offset(0f, y(meta)), Offset(w, y(meta)), 3f,
                    pathEffect = PathEffect.dashPathEffect(floatArrayOf(12f, 8f))
                )
                var anterior: Offset? = null
                valores.forEachIndexed { i, v ->
                    if (v == null) {
                        anterior = null
                    } else {
                        val p = Offset(x(i), y(v))
                        anterior?.let { drawLine(corLinha, it, p, 4f) }
                        anterior = p
                    }
                }
                valores.forEachIndexed { i, v ->
                    if (v != null) {
                        val p = Offset(x(i), y(v))
                        val cor = corMeta(v, meta, menorMelhor)
                        drawCircle(Color.White, 7f, p)
                        drawCircle(cor, 7f, p, style = Stroke(4f))
                        val txt = medidor.measure(fmt(v), estiloRotulo.copy(color = cor))
                        val topoTxt = (p.y - txt.size.height - 8f).let { if (it < 0f) p.y + 10f else it }
                        val esq = (p.x - txt.size.width / 2f).coerceIn(0f, (w - txt.size.width).coerceAtLeast(0f))
                        drawText(txt, topLeft = Offset(esq, topoTxt))
                    }
                }
            }
        }
        RotulosMeses(LarguraEixo)
        FlowRow(horizontalArrangement = Arrangement.spacedBy(18.dp)) {
            ItemLegenda(corLinha, "Realizado")
            ItemLegenda(corMetaLinha, "Meta ${if (menorMelhor) "≤" else "≥"} ${fmt(meta)}", tracejado = true)
        }
    }
}

private data class SerieBarra(val rotulo: String, val cor: Color, val valores: List<Double>)

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun GraficoBarras(
    titulo: String,
    subtitulo: String,
    series: List<SerieBarra>,
    fmt: (Double) -> String,
    modifier: Modifier,
    grande: Boolean
) {
    val medidor = rememberTextMeasurer()
    val altura = if (grande) 280.dp else 210.dp
    val totais = (0 until 12).map { i -> series.sumOf { it.valores.getOrElse(i) { 0.0 } } }
    val topo = (totais.maxOrNull() ?: 0.0).let { if (it <= 0) 1.0 else it * 1.18 }
    val estiloRotulo = TextStyle(fontSize = if (grande) 12.sp else 10.sp, fontWeight = FontWeight.SemiBold, color = PortalCores.TextoForte)
    CartaoSecao(titulo, modifier, subtitulo) {
        Row(Modifier.fillMaxWidth()) {
            Column(
                Modifier.width(LarguraEixo - 6.dp).height(altura),
                verticalArrangement = Arrangement.SpaceBetween,
                horizontalAlignment = Alignment.End
            ) {
                listOf(topo, topo / 2, 0.0).forEach {
                    Text(fmt(it), style = MaterialTheme.typography.labelSmall, color = PortalCores.CinzaClaro, maxLines = 1)
                }
            }
            Spacer(Modifier.width(6.dp))
            Canvas(Modifier.weight(1f).height(altura)) {
                val w = size.width
                val h = size.height
                fun y(v: Double) = (h - (v / topo) * h).toFloat()
                val faixa = w / 12f
                val larguraBarra = faixa * 0.56f
                listOf(0.0, topo / 2, topo).forEach {
                    drawLine(PortalCores.Borda, Offset(0f, y(it)), Offset(w, y(it)), 1.5f)
                }
                for (i in 0 until 12) {
                    val cx = faixa * (i + 0.5f)
                    var base = 0.0
                    series.forEach { s ->
                        val v = s.valores.getOrElse(i) { 0.0 }
                        if (v > 0) {
                            val topoBarra = y(base + v)
                            drawRect(s.cor, Offset(cx - larguraBarra / 2, topoBarra), Size(larguraBarra, y(base) - topoBarra))
                            base += v
                        }
                    }
                    if (totais[i] > 0) {
                        val txt = medidor.measure(fmt(totais[i]), estiloRotulo)
                        val esq = (cx - txt.size.width / 2f).coerceIn(0f, (w - txt.size.width).coerceAtLeast(0f))
                        drawText(txt, topLeft = Offset(esq, (y(totais[i]) - txt.size.height - 4f).coerceAtLeast(0f)))
                    }
                }
            }
        }
        RotulosMeses(LarguraEixo)
        if (series.size > 1) {
            FlowRow(horizontalArrangement = Arrangement.spacedBy(18.dp)) {
                series.forEach { ItemLegenda(it.cor, it.rotulo) }
            }
        }
    }
}

@Composable
private fun ApresentacaoRem(
    obra: String,
    ano: Int,
    meses: List<RemMonthRow>,
    visao: RemVisao,
    onVisao: (RemVisao) -> Unit,
    onFechar: () -> Unit
) {
    Dialog(onDismissRequest = onFechar, properties = DialogProperties(usePlatformDefaultWidth = false)) {
        BoxWithConstraints(Modifier.fillMaxSize().background(PortalCores.FundoPainel)) {
            val largo = maxWidth >= 900.dp
            val ultimo = remember(meses, visao) { RemCalc.resumo(RemCalc.serie(meses, visao)).ultimoMes }
            val rolagem578 = androidx.compose.foundation.rememberScrollState()
            br.com.htms.inspeccaocampo.ui.kit.AreaRolavel(rolagem578, Modifier.fillMaxSize()) {
            Column( Modifier.fillMaxSize().verticalScroll(rolagem578).padding(if (largo) 32.dp else 14.dp),
                verticalArrangement = Arrangement.spacedBy(18.dp)
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Column(Modifier.weight(1f)) {
                        Text(
                            "REM — Segurança do Trabalho",
                            style = if (largo) MaterialTheme.typography.headlineMedium else MaterialTheme.typography.titleLarge,
                            fontWeight = FontWeight.Bold,
                            color = PortalCores.Navy
                        )
                Text(
                            "$obra · $ano · ${visao.rotulo}" + (ultimo?.let { " · dados até ${RemMeses.rotulo(it)}" } ?: ""),
                            style = MaterialTheme.typography.titleMedium,
                            color = PortalCores.CinzaTexto
                        )
                    }
                    IconButton(onClick = onFechar) { Icon(Icons.Filled.Close, contentDescription = "Fechar apresentação", tint = PortalCores.Navy) }
                }
                SeletorVisao(visao, onVisao)
                DashboardRem(meses, visao, largo, grande = true)
            }
            }
        }
    }
}

// ---------- Planilha anual ----------

private data class ColunaRem(
    val titulo: String,
    val largura: Dp,
    val valor: (RemIndicadores) -> String,
    val total: (RemResumoAno) -> String = { "" },
    val cor: ((RemIndicadores) -> Color)? = null
)

@Composable
private fun PlanilhaAnualRem(meses: List<RemMonthRow>, visao: RemVisao, onAbrir: (RemAbrangencia, Int) -> Unit) {
    val meta = LocalRemMetas.current
    val serie = remember(meses, visao) { RemCalc.serie(meses, visao) }
    val r = remember(serie) { RemCalc.resumo(serie) }
    fun q(v: Double, i: RemIndicadores) = if (i.valores.preenchido) RemFmt.qtd(v) else ""
    fun taxaCor(v: Double?, meta: Double, menorMelhor: Boolean) = if (v == null) PortalCores.CinzaClaro else corMeta(v, meta, menorMelhor)
    val abrDaVisao = if (visao == RemVisao.SUBCONTRATADOS) RemAbrangencia.SUBCONTRATADOS else RemAbrangencia.HTMS

    val colunas = buildList {
        add(ColunaRem("Mês", 56.dp, { RemMeses.rotulo(it.mes) }, { "Total" }))
        if (visao != RemVisao.CONSOLIDADO) {
            add(ColunaRem("Situação", 84.dp, { i ->
                val row = meses.find { it.abrangencia == abrDaVisao && it.mes == i.mes }
                when {
                    row == null -> ""
                    row.id != null || row.updatedAt != null -> "Salvo"
                    i.valores.preenchido -> "Rascunho"
                    else -> ""
                }
            }, cor = { i ->
                val row = meses.find { it.abrangencia == abrDaVisao && it.mes == i.mes }
                if (row?.id != null || row?.updatedAt != null) PortalCores.Verde else PortalCores.Laranja
            }))
        }
        add(ColunaRem("Colab.", 64.dp, { q(it.valores.colaboradores, it) }, { "méd. " + RemFmt.num(it.mediaColaboradores, 0) }))
        add(ColunaRem("HHER", 92.dp, { q(it.valores.hher, it) }, { RemFmt.qtd(it.total.hher) }))
        add(ColunaRem("HH trein.", 80.dp, { q(it.valores.hhTreinamento, it) }, { RemFmt.qtd(it.total.hhTreinamento) }))
        add(ColunaRem("Absent. (h)", 84.dp, { q(it.valores.horasAbsenteismo, it) }, { RemFmt.qtd(it.total.horasAbsenteismo) }))
        add(ColunaRem("CAT", 48.dp, { q(it.valores.cat, it) }, { RemFmt.qtd(it.total.cat) }))
        add(ColunaRem("Lesão c/ af.", 84.dp, { q(it.valores.lesaoCom, it) }, { RemFmt.qtd(it.total.lesaoCom) }))
        add(ColunaRem("s/ af.", 56.dp, { q(it.valores.lesaoSem, it) }, { RemFmt.qtd(it.total.lesaoSem) }))
        add(ColunaRem("Amb.", 52.dp, { q(it.valores.lesaoAmb, it) }, { RemFmt.qtd(it.total.lesaoAmb) }))
        add(ColunaRem("Dias perd.", 76.dp, { q(it.valores.diasPerdidos, it) }, { RemFmt.qtd(it.total.diasPerdidos) }))
        add(ColunaRem("Transp.", 64.dp, { q(it.valores.diasTransportados, it) }, { RemFmt.qtd(it.total.diasTransportados) }))
        add(ColunaRem("Debit.", 60.dp, { q(it.valores.diasDebitados, it) }, { RemFmt.qtd(it.total.diasDebitados) }))
        add(ColunaRem("Trajeto", 64.dp, { q(it.valores.acidentesTrajeto, it) }, { RemFmt.qtd(it.total.acidentesTrajeto) }))
        add(ColunaRem("Traj. dias", 72.dp, { q(it.valores.trajDiasPerdidos, it) }, { RemFmt.qtd(it.total.trajDiasPerdidos) }))
        add(ColunaRem("Danos", 56.dp, { q(it.valores.danos, it) }, { RemFmt.qtd(it.total.danos) }))
        add(ColunaRem("TFSA mês", 80.dp, { RemFmt.taxa(it.tfsaMes) }))
        add(ColunaRem("TFSA acum.", 86.dp, { RemFmt.taxa(it.tfsaAcum) }, { RemFmt.taxa(it.tfsa) }, { taxaCor(it.tfsaAcum, meta.tfsa, true) }))
        add(ColunaRem("TFCA mês", 80.dp, { RemFmt.taxa(it.tfcaMes) }))
        add(ColunaRem("TFCA acum.", 86.dp, { RemFmt.taxa(it.tfcaAcum) }, { RemFmt.taxa(it.tfca) }, { taxaCor(it.tfcaAcum, meta.tfca, true) }))
        add(ColunaRem("TG acum.", 86.dp, { RemFmt.taxa(it.tgAcum) }, { RemFmt.taxa(it.tg) }, { taxaCor(it.tgAcum, meta.tg, true) }))
        add(ColunaRem("Absent.", 72.dp, { RemFmt.pct(it.absenteismo) }, { RemFmt.pct(it.absenteismo) }, { taxaCor(it.absenteismo, meta.absenteismo, true) }))
        add(ColunaRem("Trein.", 72.dp, { RemFmt.pct(it.treinamento) }, { RemFmt.pct(it.treinamento) }, { taxaCor(it.treinamento, meta.treinamento, false) }))
    }
    val larguraTotal = colunas.fold(0.dp) { acc, c -> acc + c.largura } + 24.dp

    CartaoSecao(
        titulo = "Planilha anual — ${visao.rotulo}",
        subtitulo = "Mesmas fórmulas do Excel. Taxas por milhão de HHER; cores comparam com a meta " +
            "(TFSA ≤ ${RemFmt.qtd(meta.tfsa)}, TFCA ≤ ${RemFmt.qtd(meta.tfca)}, TG ≤ ${RemFmt.qtd(meta.tg)}, " +
            "absenteísmo ≤ ${RemFmt.pct(meta.absenteismo)}, treinamento ≥ ${RemFmt.pct(meta.treinamento)}). Clique no mês para editar."
    ) {
        Box(
            Modifier.fillMaxWidth()
                .border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp))
                .horizontalScroll(rememberScrollState())
        ) {
            Column(Modifier.width(larguraTotal)) {
                Row(
                    Modifier.fillMaxWidth().background(PortalCores.CabecalhoTabela).padding(horizontal = 12.dp, vertical = 10.dp)
                ) {
                    colunas.forEach {
                        Text(
                            it.titulo, Modifier.width(it.largura), style = MaterialTheme.typography.labelMedium,
                            fontWeight = FontWeight.SemiBold, color = PortalCores.TextoForte, maxLines = 1
                        )
                    }
                }
                serie.forEach { i ->
                    HorizontalDivider(color = PortalCores.Borda)
                    Row(
                        Modifier.fillMaxWidth()
                            .clickable {
                                val abr = if (visao == RemVisao.SUBCONTRATADOS) RemAbrangencia.SUBCONTRATADOS else RemAbrangencia.HTMS
                                onAbrir(abr, i.mes)
                            }
                            .padding(horizontal = 12.dp, vertical = 9.dp)
                    ) {
                        colunas.forEachIndexed { idx, c ->
                            Text(
                                c.valor(i), Modifier.width(c.largura), style = MaterialTheme.typography.bodyMedium,
                                fontWeight = if (idx == 0) FontWeight.SemiBold else FontWeight.Normal,
                                color = c.cor?.invoke(i) ?: if (i.valores.preenchido) PortalCores.Texto else PortalCores.CinzaClaro,
                                maxLines = 1
                            )
                        }
                    }
                }
                HorizontalDivider(color = PortalCores.Borda)
                Row(
                    Modifier.fillMaxWidth().background(PortalCores.AzulClaro).padding(horizontal = 12.dp, vertical = 10.dp)
                ) {
                    colunas.forEach { c ->
                        Text(
                            c.total(r), Modifier.width(c.largura), style = MaterialTheme.typography.bodyMedium,
                            fontWeight = FontWeight.Bold, color = PortalCores.Navy, maxLines = 1
                        )
                    }
                }
            }
        }
    }
}

// ---------- Lançamento mensal ----------

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun LancamentoRem(
    controller: AppController,
    form: FormRemSeguranca,
    meses: List<RemMonthRow>,
    salvando: Boolean,
    largo: Boolean
) {
    val ro = form.readOnly
    val p = form.payload
    var colaboradores by remember { mutableStateOf<List<Funcionario>>(emptyList()) }
    LaunchedEffect(Unit) {
        FuncionariosApi.listar().onSuccess { lista ->
            colaboradores = lista
                .filter { !it.situacao.trim().uppercase().startsWith("DESATIV") }
                .sortedBy { it.nome }
        }
    }
    val sub = form.abrangencia == RemAbrangencia.SUBCONTRATADOS
    val chave = "${form.abrangencia}-${form.mes}-${form.empresaTabIndex}"
    val set: (RemMonthPayload) -> Unit = { controller.atualizarRemPayload(it) }
    val colunas = if (largo) 3 else 2

    CartaoSecao(
        titulo = "Período",
        subtitulo = "Escolha HTMS ou subcontratados e o mês. Verde = salvo no servidor; laranja = rascunho neste aparelho."
    ) {
        LinhaOpcoes(
            opcoes = RemAbrangencia.entries,
            selecionada = form.abrangencia,
            rotulo = { it.rotulo },
            cor = { PortalCores.Navy },
            onSelect = { controller.selecionarRemAbrangencia(it) },
            modifier = Modifier.widthIn(max = 520.dp)
        )
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    (1..12).forEach { m ->
                val row = meses.find { it.abrangencia == form.abrangencia && it.mes == m }
                val salvo = row != null && (row.id != null || row.updatedAt != null)
                val rascunho = !salvo && row != null && RemCalc.valores(row.payload, form.abrangencia).preenchido
                ChipMes(RemMeses.rotulo(m), m == form.mes, if (salvo) PortalCores.Verde else if (rascunho) PortalCores.Laranja else null) {
                                controller.selecionarRemMes(m)
                }
            }
        }
    }

    if (ro) {
        Text(
            "Este mês já foi salvo no servidor e está somente leitura. Para corrigir, peça a um administrador.",
            modifier = Modifier.fillMaxWidth()
                .background(PortalCores.Vermelho.copy(alpha = 0.08f), RoundedCornerShape(10.dp))
                .padding(14.dp),
            color = PortalCores.Vermelho,
            style = MaterialTheme.typography.bodyMedium
        )
    }

    if (sub) {
        val blocos = p.empresasBlocosNormalizados()
        val idx = form.empresaTabIndex.coerceIn(0, blocos.lastIndex.coerceAtLeast(0))
        CartaoSecao(
            titulo = "Empresas subcontratadas",
            subtitulo = "Cada empresa tem seus números; o Excel soma todas na linha do mês e lista os nomes na aba SUBCONTRATADOS."
        ) {
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                blocos.forEachIndexed { i, b ->
                    ChipMes(b.rotuloAba(i), i == idx, null) { controller.selecionarRemEmpresaTab(i) }
                }
                if (!ro) ChipMes("+ Empresa", false, null) { controller.adicionarRemEmpresaTab() }
            }
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                Campo("Nome da empresa", p.blocoAt(idx).nome, somenteLeitura = ro, modifier = Modifier.weight(1f)) {
                    if (!ro) controller.atualizarRemEmpresaNome(it)
                }
                if (blocos.size > 1 && !ro) {
                    TextButton(onClick = { controller.removerRemEmpresaTab(idx) }) {
                        Text("Remover empresa", color = PortalCores.Vermelho)
                    }
                }
            }
        }
    }

    val visaoAbr = if (sub) RemVisao.SUBCONTRATADOS else RemVisao.HTMS
    val serie = remember(meses, visaoAbr) { RemCalc.serie(meses, visaoAbr) }
    val ind = serie[form.mes - 1]

    val campos: @Composable (Modifier) -> Unit = { m ->
        Column(m, verticalArrangement = Arrangement.spacedBy(18.dp)) {
            CartaoSecao(
                titulo = "Efetivo e horas",
                subtitulo = if (sub) "Da empresa selecionada." else "HHER = homem-hora de exposição ao risco no mês."
            ) {
                Grade(
                    colunas,
                    listOf<@Composable (Modifier) -> Unit>(
                        { mm -> CampoNum("Nº de colaboradores", p.numeroColaboradores, ro, "$chave-col", mm) { set(p.copy(numeroColaboradores = it)) } },
                        { mm -> CampoNum("HHER (horas)", p.hher, ro, "$chave-hher", mm) { set(p.copy(hher = it)) } },
                        { mm -> CampoNum("Homem-hora de treinamento", p.homemHoraTreinamento, ro, "$chave-trein", mm) { set(p.copy(homemHoraTreinamento = it)) } },
                        { mm -> CampoNum("Horas de absenteísmo", p.horaAbsenteismoMedico, ro, "$chave-abs", mm) { set(p.copy(horaAbsenteismoMedico = it)) } },
                        { mm -> CampoNum("Nº de CAT", p.numeroCat, ro, "$chave-cat", mm) { set(p.copy(numeroCat = it)) } },
                        { mm -> CampoNum("Danos à propriedade", p.danosPropriedade, ro, "$chave-danos", mm) { set(p.copy(danosPropriedade = it)) } }
                    )
                )
            }
            CartaoSecao(
                titulo = "Ocorrências com lesão",
                subtitulo = "Dias perdidos = afastamento que caiu neste mês. Transportados = a parte deles que vem de acidente " +
                    "de mês anterior. Debitados = total do afastamento do acidente."
            ) {
                Grade(colunas, camposOcorrencia(p.ocorrenciasComLesao, ro, "$chave-les") { set(p.copy(ocorrenciasComLesao = it)) })
            }
            CartaoSecao(titulo = "Ocorrências de trajeto", subtitulo = "Não entram nas taxas TFCA, TFSA e TG.") {
                Grade(colunas, camposOcorrencia(p.ocorrenciasTrajeto, ro, "$chave-traj") { set(p.copy(ocorrenciasTrajeto = it)) })
            }
            CartaoSecao(
                titulo = "Justificativa do absenteísmo",
                subtitulo = if (sub) {
                    "Nome, motivo e período da empresa selecionada. A soma das horas entra no indicador."
                } else {
                    "Informe o colaborador, o motivo da ausência e o período. A soma das horas entra no indicador."
                }
            ) {
                val linhas = p.ausencias.ifEmpty { listOf(RemAusencia()) }
                linhas.forEachIndexed { i, a ->
                    Column(Modifier.fillMaxWidth().padding(bottom = 8.dp)) {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            if (ro || colaboradores.isEmpty()) {
                                Campo("Colaborador ${i + 1}", a.nome, somenteLeitura = ro, modifier = Modifier.weight(1f)) { v ->
                                    if (!ro) set(p.comAusencias(linhas.toMutableList().also { if (i in it.indices) it[i] = a.copy(nome = v) }))
                                }
                            } else {
                                val idSel = colaboradores.firstOrNull { it.nome.equals(a.nome.trim(), ignoreCase = true) }?.id ?: a.nome
                                SeletorBusca(
                                    "Colaborador ${i + 1}",
                                    colaboradores.map { it.id to it.nomeComVinculo },
                                    idSel,
                                    { id ->
                                        val nome = colaboradores.firstOrNull { it.id == id }?.nome ?: return@SeletorBusca
                                        set(p.comAusencias(linhas.toMutableList().also { if (i in it.indices) it[i] = a.copy(nome = nome) }))
                                    },
                                    Modifier.weight(1f),
                                    embutido = true
                                )
                            }
                            if (!ro && linhas.size > 1) {
                                IconButton(onClick = {
                                    set(p.comAusencias(linhas.toMutableList().also { if (i in it.indices) it.removeAt(i) }))
                                }) { Icon(Icons.Filled.Delete, contentDescription = "Remover justificativa", tint = PortalCores.CinzaTexto) }
                            }
                        }
                        Seletor(
                            "Motivo da ausência",
                            listOf("" to "Selecione") + RemAusencia.MOTIVOS.map { it to it },
                            a.motivo,
                            { v -> if (!ro) set(p.comAusencias(linhas.toMutableList().also { if (i in it.indices) it[i] = a.copy(motivo = v) })) },
                            Modifier.fillMaxWidth()
                        )
                        Grade(
                            colunas,
                            listOf(
                                { mm -> Campo("Início (dd/mm/aaaa)", a.inicio, somenteLeitura = ro, modifier = mm) { v ->
                                    if (!ro) set(p.comAusencias(linhas.toMutableList().also { if (i in it.indices) it[i] = a.copy(inicio = v) }))
                                } },
                                { mm -> Campo("Término (dd/mm/aaaa)", a.fim, somenteLeitura = ro, modifier = mm) { v ->
                                    if (!ro) set(p.comAusencias(linhas.toMutableList().also { if (i in it.indices) it[i] = a.copy(fim = v) }))
                                } },
                                { mm -> CampoNum("Período (horas)", a.horas, ro, "$chave-aus-$i", mm) { h ->
                                    set(p.comAusencias(linhas.toMutableList().also { if (i in it.indices) it[i] = a.copy(horas = h) }))
                                } }
                            )
                        )
                    }
                }
                if (!ro) {
                    TextButton(onClick = { set(p.comAusencias(linhas + RemAusencia())) }) { Text("+ Adicionar justificativa") }
                }
            }
        }
    }
    val previa: @Composable (Modifier) -> Unit = { m ->
        PreviaMes(form, ind, ro, salvando, m) { controller.salvarRemMesAtual() }
    }
    if (largo) {
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(18.dp)) {
            campos(Modifier.weight(2f))
            previa(Modifier.weight(1f))
        }
    } else {
        campos(Modifier.fillMaxWidth())
        previa(Modifier.fillMaxWidth())
    }
}

private fun camposOcorrencia(
    b: RemOcorrenciasBreakdown,
    ro: Boolean,
    chave: String,
    onChange: (RemOcorrenciasBreakdown) -> Unit
): List<@Composable (Modifier) -> Unit> = listOf(
    { m -> CampoNum("Com afastamento", b.comAfastamento, ro, "$chave-ca", m) { onChange(b.copy(comAfastamento = it)) } },
    { m -> CampoNum("Sem afastamento", b.semAfastamento, ro, "$chave-sa", m) { onChange(b.copy(semAfastamento = it)) } },
    { m -> CampoNum("Simples atendimento ambulatorial", b.simplesAtendimentoAmbulatorial, ro, "$chave-amb", m) { onChange(b.copy(simplesAtendimentoAmbulatorial = it)) } },
    { m -> CampoNum("Dias perdidos no mês", b.diasPerdidosNoMes, ro, "$chave-dp", m) { onChange(b.copy(diasPerdidosNoMes = it)) } },
    { m -> CampoNum("Dias transportados", b.diasTransportados, ro, "$chave-dt", m) { onChange(b.copy(diasTransportados = it)) } },
    { m -> CampoNum("Dias debitados", b.diasDebitados, ro, "$chave-dd", m) { onChange(b.copy(diasDebitados = it)) } }
)

@Composable
private fun PreviaMes(
    form: FormRemSeguranca,
    ind: RemIndicadores,
    ro: Boolean,
    salvando: Boolean,
    modifier: Modifier,
    onSalvar: () -> Unit
) {
    val meta = LocalRemMetas.current
    val alertas = RemCalc.alertas(ind.valores)
    CartaoSecao(
        titulo = "Indicadores de ${RemMeses.rotulo(form.mes)}",
        modifier = modifier,
        subtitulo = form.abrangencia.rotulo + if (form.abrangencia == RemAbrangencia.SUBCONTRATADOS) " (todas as empresas)" else ""
    ) {
        LinhaIndicador("TFCA do mês", RemFmt.taxa(ind.tfcaMes), corMeta(ind.tfcaMes, meta.tfca, true))
        LinhaIndicador("TFCA acumulada", RemFmt.taxa(ind.tfcaAcum), corMeta(ind.tfcaAcum, meta.tfca, true), "meta ≤ ${RemFmt.qtd(meta.tfca)}")
        LinhaIndicador("TFSA do mês", RemFmt.taxa(ind.tfsaMes), corMeta(ind.tfsaMes, meta.tfsa, true))
        LinhaIndicador("TFSA acumulada", RemFmt.taxa(ind.tfsaAcum), corMeta(ind.tfsaAcum, meta.tfsa, true), "meta ≤ ${RemFmt.qtd(meta.tfsa)}")
        LinhaIndicador("TG acumulada", RemFmt.taxa(ind.tgAcum), corMeta(ind.tgAcum, meta.tg, true), "meta ≤ ${RemFmt.qtd(meta.tg)}")
        LinhaIndicador("Absenteísmo", RemFmt.pct(ind.absenteismo), corMeta(ind.absenteismo, meta.absenteismo, true), "meta ≤ ${RemFmt.pct(meta.absenteismo)}")
        LinhaIndicador("Treinamento", RemFmt.pct(ind.treinamento), corMeta(ind.treinamento, meta.treinamento, false), "meta ≥ ${RemFmt.pct(meta.treinamento)}")
        HorizontalDivider(color = PortalCores.Borda)
        Text("Conferência", fontWeight = FontWeight.SemiBold, color = PortalCores.Navy)
        if (!ind.valores.preenchido) {
            Text("Mês ainda sem números.", style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
        } else if (alertas.isEmpty()) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Filled.CheckCircle, contentDescription = null, tint = PortalCores.Verde, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(6.dp))
                Text("Nenhuma inconsistência encontrada.", style = MaterialTheme.typography.bodySmall, color = PortalCores.Verde)
            }
        } else {
            alertas.forEach { a ->
                Row(verticalAlignment = Alignment.Top) {
                    Icon(Icons.Filled.Warning, contentDescription = null, tint = PortalCores.Laranja, modifier = Modifier.size(18.dp))
                    Spacer(Modifier.width(6.dp))
                    Text(a, style = MaterialTheme.typography.bodySmall, color = PortalCores.Texto)
                }
            }
        }
        PortalButton(onClick = onSalvar, enabled = !salvando && !ro, modifier = Modifier.fillMaxWidth()) {
            Text(if (salvando) "Salvando..." else "Salvar ${RemMeses.rotulo(form.mes)}")
        }
        Text(
            "Depois de salvo, o mês fica somente leitura para quem não é administrador.",
            style = MaterialTheme.typography.bodySmall,
            color = PortalCores.CinzaClaro
        )
    }
}

@Composable
private fun LinhaIndicador(rotulo: String, valor: String, cor: Color, meta: String = "") {
    Row(verticalAlignment = Alignment.CenterVertically) {
        Column(Modifier.weight(1f)) {
            Text(rotulo, style = MaterialTheme.typography.bodyMedium, color = PortalCores.Texto)
            if (meta.isNotBlank()) Text(meta, style = MaterialTheme.typography.labelSmall, color = PortalCores.CinzaClaro)
        }
        Text(valor, fontWeight = FontWeight.Bold, color = cor, style = MaterialTheme.typography.titleMedium)
    }
}

@Composable
private fun ChipMes(texto: String, selecionado: Boolean, status: Color?, onClick: () -> Unit) {
    val forma = RoundedCornerShape(10.dp)
    Row(
        Modifier
            .background(if (selecionado) PortalCores.Marca else PortalCores.Cartao, forma)
            .border(1.dp, if (selecionado) PortalCores.Marca else PortalCores.BordaCampo, forma)
            .clickable(onClick = onClick)
            .padding(horizontal = 14.dp, vertical = 8.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        if (status != null) {
            Box(Modifier.size(8.dp).background(status, CircleShape))
            Spacer(Modifier.width(6.dp))
        }
        Text(
            texto,
            color = if (selecionado) Color.White else PortalCores.Navy,
            fontWeight = FontWeight.SemiBold,
            style = MaterialTheme.typography.labelLarge,
            maxLines = 1
        )
    }
}

@Composable
private fun Grade(colunas: Int, itens: List<@Composable (Modifier) -> Unit>) {
    Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
        itens.chunked(colunas).forEach { linha ->
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                linha.forEach { it(Modifier.weight(1f)) }
                repeat(colunas - linha.size) { Spacer(Modifier.weight(1f)) }
            }
        }
    }
}

private fun numTexto(v: Double?): String =
    v?.let { if (it % 1.0 == 0.0) it.toLong().toString() else it.toString().replace('.', ',') }.orEmpty()

private fun lerNum(s: String): Double? {
    val t = s.trim()
    if (t.isEmpty()) return null
    val normal = if (t.contains(',')) t.replace(".", "").replace(',', '.') else t
    return normal.toDoubleOrNull()
}

@Composable
private fun CampoNum(
    label: String,
    valor: Double?,
    ro: Boolean,
    chave: String,
    modifier: Modifier,
    onChange: (Double?) -> Unit
) {
    var texto by remember(chave) { mutableStateOf(numTexto(valor)) }
    LaunchedEffect(valor) {
        if (lerNum(texto) != valor) texto = numTexto(valor)
    }
    Campo(label, texto, numero = true, somenteLeitura = ro, modifier = modifier) { bruto ->
        if (!ro) {
            val limpo = bruto.filter { it.isDigit() || it == ',' || it == '.' }
            texto = limpo
            onChange(lerNum(limpo))
        }
    }
}

// ---------- Administração (Master) ----------

@Composable
private fun AdminRem(
    controller: AppController,
    form: FormRemSeguranca,
    salvando: Boolean,
    isMaster: Boolean,
    metas: RemMetas,
    onMetas: (RemMetas) -> Unit,
    onZerar: (String) -> Unit
) {
    var tfca by remember(metas) { mutableStateOf(RemFmt.qtd(metas.tfca)) }
    var tfsa by remember(metas) { mutableStateOf(RemFmt.qtd(metas.tfsa)) }
    var tg by remember(metas) { mutableStateOf(RemFmt.qtd(metas.tg)) }
    var abs by remember(metas) { mutableStateOf(RemFmt.qtd(metas.absenteismo * 100)) }
    var trein by remember(metas) { mutableStateOf(RemFmt.qtd(metas.treinamento * 100)) }
    var msg by remember { mutableStateOf<String?>(null) }
    var ok by remember { mutableStateOf(true) }
    var gravando by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()
    fun limpo(s: String) = s.filter { it.isDigit() || it == ',' || it == '.' }
    CartaoSecao(
        titulo = "Ajustar metas",
        subtitulo = "Muda só as metas dos indicadores. O que já foi lançado no mês continua igual. " +
            "TFCA, TFSA e TG são por milhão de HHER (quanto menor, melhor). Absenteísmo e treinamento entram em percentual."
    ) {
        Campo("TFCA (meta ≤)", tfca, numero = true) { tfca = limpo(it) }
        Campo("TFSA (meta ≤)", tfsa, numero = true) { tfsa = limpo(it) }
        Campo("TG (meta ≤)", tg, numero = true) { tg = limpo(it) }
        Campo("Absenteísmo % (meta ≤)", abs, numero = true) { abs = limpo(it) }
        Campo("Treinamento % (meta ≥)", trein, numero = true) { trein = limpo(it) }
        msg?.let { Text(it, color = if (ok) PortalCores.Verde else PortalCores.Vermelho) }
        PortalButton(
            onClick = {
                val novo = RemMetas(
                    tfsa = lerNum(tfsa) ?: metas.tfsa,
                    tfca = lerNum(tfca) ?: metas.tfca,
                    tg = lerNum(tg) ?: metas.tg,
                    treinamento = (lerNum(trein) ?: (metas.treinamento * 100)) / 100.0,
                    absenteismo = (lerNum(abs) ?: (metas.absenteismo * 100)) / 100.0
                )
                gravando = true
                msg = null
                scope.launch {
                    AuthApi.saveRemMetasJson(novo.json())
                        .onSuccess {
                            onMetas(novo)
                            ok = true
                            msg = "Metas salvas."
                        }
                        .onFailure {
                            ok = false
                            msg = it.message ?: "Falha ao salvar as metas."
                        }
                    gravando = false
                }
            },
            enabled = !gravando
        ) {
            Text(if (gravando) "Salvando..." else "Salvar metas")
        }
    }
    if (!isMaster) return
    CartaoSecao(
        titulo = "Zerar dados do REM",
        subtitulo = "Somente o admin master. Afeta todos os usuários no servidor e não pode ser desfeito."
    ) {
        Seletor(
            "Mês (para zerar mês)",
            RemMeses.rotulos.mapIndexed { i, r -> (i + 1).toString() to r },
            form.mes.toString(),
            { v -> v.toIntOrNull()?.let { controller.selecionarRemMes(it) } },
            Modifier.widthIn(max = 320.dp).fillMaxWidth()
        )
        PortalOutlinedButton(onClick = { onZerar("mes") }, enabled = !salvando && form.obra.isNotBlank()) {
            Text("Zerar mês (${RemMeses.rotulo(form.mes)}/${form.ano})", color = PortalCores.Vermelho)
        }
        PortalOutlinedButton(onClick = { onZerar("obra_ano") }, enabled = !salvando && form.obra.isNotBlank()) {
            Text("Zerar obra/ano (${form.obra.ifBlank { "…" }} / ${form.ano})", color = PortalCores.Vermelho)
        }
        PortalOutlinedButton(onClick = { onZerar("geral") }, enabled = !salvando) {
            Text("Zerar REM geral (tudo)", color = PortalCores.Vermelho)
        }
    }
}
